define((require) => {
    "use strict";

    var Backbone       = require("backbone"),
        ShareRecipient = require("ui/share/ShareRecipient");

    /**
     * A collection of ShareRecipient.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientCollection
     * @constructor
     */
    return Backbone.Collection.extend({
        model: ShareRecipient
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareRecipientCollection.js